<template>
  <section>
    <v-tabs
      v-model="tab"
      grow
    >
      <v-tab>
        Subscription Plan
      </v-tab>
    </v-tabs>

    <v-tabs-items v-model="tab">
      <v-tab-item
      >
        <v-container>
          <v-alert type="success" dismissible v-show="plan_alert_success">
            Your plan has been updated successfully.
          </v-alert>
          <v-alert type="error" dismissible v-show="plan_alert_error">
            We were unable to change your plan - please contact support.
          </v-alert>
              <v-row>
                <v-col>
                  <v-card
                  class="mx-auto"
                  max-width="344"
                  outlined
                  >
                    <v-card-title>Free</v-card-title>
                    <v-card-text>1-week Trial
                      
                      <br/>3 face filters (clear skin, lighting, and lipstick)
                      <br/>works with Zoom & Google Meet</v-card-text>
                      <v-card-actions>
                      <v-btn
                      outlined
                      rounded
                      :disabled="subscription_plan=='free'"
                      @click="subscribe_free_plan()"
                      >
                      {{ subscription_plan!='free' ? 'Select' : 'Your Current Plan' }}
                      </v-btn>
                      </v-card-actions>
                  </v-card>
                </v-col>
                <v-col>
                  <v-card
                  class="mx-auto"
                  max-width="344"
                  outlined
                  >
                    <v-card-title>Pro</v-card-title>
                    <v-card-text>$27/month
                      
                      <br/>3 face filters (clear skin, lipstick, face lighting)
                      <br/>Works with Zoom, Google Meet
                      <br/>custom filter colors & intensity
                      <br/>higher video quality (resolution)
                      </v-card-text>
                      <v-card-actions>
                      <v-btn
                      outlined
                      rounded
                      :disabled="subscription_plan=='pro'"
                      @click="upgrade('pro')"
                      >
                      {{ subscription_plan!='pro' ? 'Upgrade' : 'Your Current Plan' }}
                      </v-btn>
                      </v-card-actions>
                  </v-card>
                </v-col>
              </v-row>
        </v-container>

        <br/>
        <br/>
        <br/>
        <div v-show="show_checkout" id="stripe-checkout" class="col-md-6 custom-card-design">
          <v-alert type="success" dismissible v-show="alert_success">
            Your card has been charged successfully.
          </v-alert>
          <v-alert type="error" dismissible v-show="alert_error">
            We were unable to charge your card - please contact support.
          </v-alert>
          <form action="" method="post" id="payment-form">

            <label for="card-element" class="credit-text">
              <label class="currency-text">We accept all major debit/credit cards in 135+ currencies.</label>
            </label>
            <br/>
            <div id="card-element">
              <!-- a Stripe Element will be inserted here. -->
            </div>

            <!-- Used to display Element errors -->
            <div id="card-errors" role="alert"></div>

            <br/>
            <br/>
            <v-btn
              color="success"
              type="submit"
              :loading="pending_card_charge"
              id='submit_payment'
            >Submit Payment</v-btn>
            <br/>
          </form>
        </div>
      </v-tab-item>
    </v-tabs-items>
  </section>
</template>

<script>
var load = require('load-script')

export default {
  props: ['user', 'api_prefix', 'subscription_plan'],
  data: function () {
  return {
    tab: null,
    alert_success: false,
    alert_error: false,
    selected_plan: null,
    account_balance: null,
    pending_card_charge: false,
    show_checkout: false,
    loading: false,
    plan_alert_success: false,
    plan_alert_error: false,
    enabled_flag: false,
    }
  },
  created: function()
  {
    
  },
  mounted: function()
  {
    let self = this
    window.analytics.page('Subscription');
    
    load('https://js.stripe.com/v3/', function (err, script) 
    {
      if (err) 
      {
        // print useful message
      }
      else 
      {
        self.setup_stripe()
      }
    })
  },
  components: {
    
  },
  computed: {
  },
  watch: {

  },
  methods: {

    async subscribe_free_plan()
    {
      let self = this;
      self.show_checkout = false;
      var response = await self.$http.post(self.api_prefix + '/subscribe_free_plan',
      {});
      console.log(response);
      if(response.data==true)
      {
        self.$emit('subscription_plan_updated');
        self.plan_alert_success = true;
        self.plan_alert_error = false;
      }
      else
      {
        self.plan_alert_error = true;
        self.plan_alert_success = false;
      }
    },
    async upgrade(plan)
    {
      this.show_checkout = true;
      this.selected_plan = plan;
    },
    setup_stripe()
    {
      let self = this;
      var stripe = Stripe(process.env.VUE_APP_STRIPE_KEY);
      var elements = stripe.elements();

      var style = {
        base: {
          color: '#32325d',
          lineHeight: '18px',
          fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
          fontSmoothing: 'antialiased',
          fontSize: '16px',
          '::placeholder': {
            color: '#aab7c4'
          }
        },
        invalid: {
          color: '#fa755a',
          iconColor: '#fa755a'
        }
      };

      var card = elements.create('card', {style: style});

      // Add an instance of the card Element into the `card-element` <div>
      card.mount('#card-element');

      card.addEventListener('change', function(event) {
        var displayError = document.getElementById('card-errors');
        if (event.error) {
          displayError.textContent = event.error.message;
        } else {
          displayError.textContent = '';
        }
      });

      // Create a token or display an error when the form is submitted.
      var form = document.getElementById('payment-form');
      form.addEventListener('submit', function(event)
      {
        event.preventDefault();

        stripe.createToken(card).then(function(result)
        {
          if (result.error)
          {
            // Inform the customer that there was an error
            var errorElement = document.getElementById('card-errors');
            errorElement.textContent = result.error.message;
          }
          else
          {
            // Send the token to your server
            self.stripeTokenHandler(result.token);
          }
        });
      });
    },
    async stripeTokenHandler(stripe_token)
    {
      let self = this;

      // Insert the token ID into the form so it gets submitted to the server
      var form = document.getElementById('payment-form');
      var hiddenInput = document.createElement('input');
      hiddenInput.setAttribute('type', 'hidden');
      hiddenInput.setAttribute('name', 'stripeToken');
      hiddenInput.setAttribute('value', stripe_token.id);
      form.appendChild(hiddenInput);

      self.pending_card_charge = true

      try
      {
        var response = await self.$http.post(self.api_prefix + '/subscription',
        {
          stripe_token: stripe_token,
          selected_plan: self.selected_plan,
          receipt_email: self.user.email,
          full_name: self.user.displayName
        },
        {
          'headers': {'Authorization': self.token}
        });
        console.log(response);
        if(response.data==true)
        {
          self.alert_error = false;
          self.alert_success = true;
          self.$emit('subscription_plan_updated');
          self.plan_alert_success = true;
          self.plan_alert_error = false;
        }
        else
        {
          self.alert_error = true;
          self.alert_success = false;
          self.plan_alert_error = true;
          self.plan_alert_success = false;
        }
        self.pending_card_charge = false;
      }
      catch (error)
      {
        self.alert_error = true;
        self.alert_success = false;
      }
    },
  }
}
</script>

<style scoped>
#stripe-checkout
{
  border-top: 1px solid black;
  padding-top: 5px;
}

#card-element
{
  width: 100%;
}

.StripeElement {
  background-color: white;
  height: 40px;
  padding: 5px 12px;
  border-radius: 4px;
  border: 1px solid transparent;
  box-shadow: 0 1px 3px 0 #e6ebf1;
  -webkit-transition: box-shadow 150ms ease;
  transition: box-shadow 150ms ease;
}

.StripeElement--focus {
  box-shadow: 0 1px 3px 0 #cfd7df;
}

.StripeElement--invalid {
  border-color: #fa755a;
}

.StripeElement--webkit-autofill {
  background-color: #fefde5 !important;
}
</style>
